export default {
  data () {
    return {
      'allAttachments': [],
      // Size in MB
      'attachmentSizeLbl': 'MB',
      'attachmentSizeCap': 9
    }
  },

  computed: {
    // Size in MB
    attachmentSizeTotal () {
      return this.calcAttachments(this.allAttachments)
    },

    attachmentSizeTotalLbl () {
      return this.getAttachmentSizeTotalLbl(this.attachmentSizeTotal)
    },

    attachmentSizeCapLbl () {
      return `${this.attachmentSizeCap}${this.attachmentSizeLbl}`
    },

    attachmentSizeBadge () {
      return this.getAttachmentSizeBadge(this.attachmentSizeTotal)
    },

    violatesSizeCap () {
      return this.doesViolateSizeCap(this.attachmentSizeTotal)
    }
  },

  methods: {
    getAttachmentSizeBadge (total) {
      let badgeClass = 'badge-' + (
        this.doesViolateSizeCap(total) ? 'danger' : 'primary'
      )

      // Only insert badge if necessary.
      if (total) {
        return `<span
          class="badge ${badgeClass} font-weight-normal"
        >
          ${this.getAttachmentSizeTotalLbl(total)}
        </span>`
      }
    },

    getAttachmentSizeTotalLbl (total) {
      return `${total}${this.attachmentSizeLbl}`
    },

    calcAttachments (attachments) {
      const reducer = (accumulator, currentValue) => accumulator + currentValue

      if (attachments.length) {
        let total = attachments.map(item => item.byte_size).reduce(reducer)

        return this.kbToMb(total)
      }

      return 0
    },

    doesViolateSizeCap (total) {
      return total > this.attachmentSizeCap
    },

    kbToMb (total) {
      return Math.round(
        (total / 1000000) * 100
      ) / 100
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/AttachmentMixin.js